<div class="remove-dialog">
  <div class="warning-badge-remove ks-mb-5" style="padding-top: 12px; justify-self: center">
    <span inlineSVG="assets/icons/Error.svg" class="ks-text-danger ks-m-4"></span>
  </div>
  <h3 class="dialog-title ks-font-size-lg ks-mb-6">Remove Payment Method</h3>
  <p class="ks-text-neutral ks-font-size-sm ks-text-center ks-mb-2">
    Are you sure you want to remove<span class="ks-text-darker-neutral">
      {{ getMaskedNumber(data.method) }}</span
    >
    payment method?
  </p>
  <p class="ks-text-neutral ks-font-size-sm ks-text-center ks-mb-10">
    This action cannot be undone.
  </p>
  <div class="d-flex justify-content-center">
    <button class="ks-btn-md ks-btn-outline-neutral ks-mr-10" (click)="onCancel()">Cancel</button>
    <button class="ks-btn-md ks-btn-danger" (click)="onRemove()">Remove</button>
  </div>
</div>
